import type { Locales } from '@/constants/Locales';
import type { PeriodAbbrevEnum } from '@/constants/PeriodAbbrevEnum';
import type { ReturnInterval } from '@/constants/ReturnInterval';
import type { PortfolioVersionType } from '@/constants/PortfolioVersionType';
import type { CurrencyConversion } from './CurrencyConversion';
import type { MonthlyReturnDistributionScaleOption } from './portfolio';
import type { ActiveReturnRebalancingType } from './ActiveReturnRebalancingType';

type FactsheetPdfWithBenchmarkParams = {
  shouldShowBenchmark: 'true';
  benchmarkSymbol: string;
};

type FactsheetPdfWithOrWithoutBenchmarkParams = { shouldShowBenchmark: 'false' } | FactsheetPdfWithBenchmarkParams;

export type FactsheetPdfParamsBase = {
  returnInterval: ReturnInterval;
  period: PeriodAbbrevEnum;
  startDate: string;
  endDate: string;
  locale: Locales;
  scaleOption: MonthlyReturnDistributionScaleOption;
  version?: PortfolioVersionType;
} & FactsheetPdfWithOrWithoutBenchmarkParams &
  CurrencyConversion;

export type FactsheetActiveReturnPdfParams = FactsheetPdfParamsBase & {
  shouldShowBenchmark: 'true';
  shouldShowActiveReturn: 'true';
  benchmarkSymbol: string;
  activeReturnRebalancingType: ActiveReturnRebalancingType;
};

export type FactsheetRegimePdfParams = FactsheetPdfParamsBase & {
  regimeId: string;
};

export type FactsheetPdfParams = FactsheetPdfParamsBase | FactsheetActiveReturnPdfParams | FactsheetRegimePdfParams;

export const isFactsheetWithBenchmarkPdfParams = (
  pdfParams: FactsheetPdfWithOrWithoutBenchmarkParams,
): pdfParams is FactsheetPdfWithBenchmarkParams => {
  return (pdfParams as FactsheetPdfWithBenchmarkParams).shouldShowBenchmark === 'true';
};

export const isFactsheetActiveReturnPdfParams = (
  pdfParams: FactsheetPdfParams,
): pdfParams is FactsheetActiveReturnPdfParams => {
  return (pdfParams as FactsheetActiveReturnPdfParams).shouldShowActiveReturn === 'true';
};

export const isFactsheetRegimePdfParams = (pdfParams: FactsheetPdfParams): pdfParams is FactsheetRegimePdfParams => {
  return (pdfParams as FactsheetRegimePdfParams).regimeId !== undefined;
};
